import React from "react";
import PropTypes from "prop-types";

import RadioButtons from "core/RadioButtons";

import { UPLOAD_TYPES } from "../PhotoUploadCore/helpers";

const PhotoUploadTypeSelectForm = ({
    setCurrentUploadType,
    currentUploadType
}) => (
    <RadioButtons
        radioName="upload-type"
        fieldsetTitle="Choose an upload type"
        onClick={value => setCurrentUploadType(value)}
        defaultCheckedValue={currentUploadType}
        options={[
            {
                value: UPLOAD_TYPES.INDIVIDUAL,
                text: "Individual Photos"
            },
            {
                value: UPLOAD_TYPES.PHOTO_SHOOT,
                text: "Photo Shoot"
            }
        ]}
    />
);

PhotoUploadTypeSelectForm.propTypes = {
    setCurrentUploadType: PropTypes.func.isRequired,
    currentUploadType: PropTypes.string.isRequired
};

export default PhotoUploadTypeSelectForm;
